export default __webpack_public_path__ + "static/media/anniversary7.70eee382.webp";